module.exports = __webpack_public_path__ + "static/media/bot-avatar.89a8c435.png";